import { Button } from 'components/ui';
import { useModal } from 'contexts/modal';
import { useInfo } from 'contexts/info';
import { FormattedMessage } from 'react-intl';
import Create from 'components/space/billing_details/modal/create';

const CreateButton = ({ refetch }) => {
  const { addModal, removeModal } = useModal();
  const setInfo = useInfo();

  return (
    <Button
      onClick={() =>
        addModal(
          <Create
            handleClose={() => removeModal()}
            onSuccess={() => {
              removeModal();
              setInfo('info.billing_details.created');
              refetch();
            }}
          />
        )
      }
      variant="contained"
    >
      <FormattedMessage id="billing_details.add" />
    </Button>
  );
};

export default CreateButton;
